export enum TransactionStateEnum {
  // not sure what this is open, closed, or whatever. we'll go with undefined for now.
  Undefined = 0,
  Processed = 1,
  Refunded = 2,
  Voided = 3,
}
